import React, { useEffect, useRef, useState } from "react";

/**
 * Lightweight searchable single-select (no external dependency).
 * Props:
 *  - value: selected option value
 *  - options: [{ value, label }]
 *  - onChange: (value) => void
 *  - placeholder: string
 *  - disabled: boolean
 */
export default function SearchableSiteSelect({ value, options = [], onChange, placeholder = "Select site", disabled = false }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef = useRef(null);

  const selected = options.find((o) => String(o.value) === String(value)) || null;

  useEffect(() => {
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
        setQuery("");
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const q = query.trim().toLowerCase();
  const filtered = q ? options.filter((o) => String(o.label).toLowerCase().includes(q)) : options;

  const choose = (val) => {
    onChange?.(val);
    setOpen(false);
    setQuery("");
  };

  return (
    <div ref={wrapRef} style={{ position: "relative" }}>
      <div
        className="form-select form-select-sm"
        onClick={() => {
          if (!disabled) setOpen((p) => !p);
        }}
        title={selected ? selected.label : ""}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: selected ? "#1e293b" : "#334155" }}>
          {selected ? selected.label : placeholder}
        </span>
      </div>
      {open && !disabled ? (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            right: 0,
            zIndex: 30,
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: 8,
            boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
            maxHeight: 240,
            overflowY: "auto",
          }}
        >
          <div style={{ padding: 6, position: "sticky", top: 0, background: "#fff", borderBottom: "1px solid #f1f5f9" }}>
            <input
              autoFocus
              type="text"
              className="form-control form-control-sm"
              placeholder="Search site..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
          <button
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => choose("")}
            style={{ display: "block", width: "100%", textAlign: "left", border: "none", background: "transparent", padding: "8px 10px", fontSize: 13, color: "#6b7280", cursor: "pointer" }}
          >
            Select site
          </button>
          {filtered.length === 0 ? (
            <div style={{ padding: "8px 10px", color: "#94a3b8", fontSize: 13 }}>No sites found</div>
          ) : (
            filtered.map((o) => (
              <button
                key={o.value}
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => choose(o.value)}
                style={{
                  display: "block",
                  width: "100%",
                  textAlign: "left",
                  border: "none",
                  borderTop: "1px solid #f8fafc",
                  background: String(o.value) === String(value) ? "#fdf2f6" : "transparent",
                  padding: "8px 10px",
                  fontSize: 13,
                  cursor: "pointer",
                  color: "#1e293b",
                }}
              >
                {o.label}
              </button>
            ))
          )}
        </div>
      ) : null}
    </div>
  );
}
